import { Controller } from "@hotwired/stimulus"

// A read-out of a value the operator does not choose (Cup::Form::ValueText).
// Every possible label sits in the same grid cell with only the current one
// visible, so showing another value is a class toggle — no text measurement,
// and the box never changes width.
//
// Whoever owns the value writes it (a mapping row's target field does) by
// dispatching `value-text:set`, the same event seam the column picker's
// constraint uses: the read-out and the hidden field it posts move together,
// synchronously with the change that caused them.
export default class extends Controller {
  static targets = ["option", "field"]

  set(event) {
    this.show(event.detail.value)
  }

  show(value) {
    this.optionTargets.forEach((option) => {
      option.classList.toggle("invisible", option.dataset.value !== String(value))
    })
    if (this.hasFieldTarget) this.fieldTarget.value = value
  }
}
